import { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Home from "pages/Home";
import { useAuth } from "AuthContext";

import FullMask from "layout/FullMask";
import MessagePage from "components/MessagePage";
import Login from "pages/Login";
import ForgetPassword from "pages/ForgetPassword";
import AdminDocuments from "pages/AdminDocuments";
import Chatbot from "pages/Chatbot";

import { Button } from "antd";

function NotFound({ permission }) {
    useEffect(() => {
        document.title = `hoctot.ai - ${
            permission ? "Không có quyền truy cập" : "Trang không tồn tại"
        }`;
        // eslint-disable-next-line
    }, []);

    const navigate = useNavigate();
    return (
        <MessagePage
            status={permission ? "403" : "404"}
            title="OOPS"
            subTitle={
                permission
                    ? "Bạn không có quyền truy cập vào trang này."
                    : "Trang bạn cố gắng truy cập không tồn tại."
            }
            extra={
                <Button type="primary" onClick={() => navigate("/")}>
                    Trở về trang chủ
                </Button>
            }
        />
    );
}

export { NotFound };

var setHeaderG;

function Ro({ element, hasHeader = true, allowRole = 0 }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, firstGettingUser } = useAuth();

    if (firstGettingUser) return <FullMask />;
    if (allowRole !== null && !user) {
        navigate(`/login?next=${location.pathname}`);
        return null;
    }
    if (allowRole !== null && user.role > allowRole) {
        return <NotFound permission />;
    }
    setHeaderG(hasHeader);
    return element;
}

export default function AppRoute({ setHeader }) {
    setHeaderG = setHeader;

    return (
        <Routes>
            <Route
                path=""
                element={<Ro element={<Home />} allowRole={100} />}
            />
            {/* base */}
            <Route
                path="/login"
                element={
                    <Ro
                        hasHeader={false}
                        element={<Login />}
                        allowRole={null}
                    />
                }
            />
            <Route
                path="/forget-password"
                element={
                    <Ro
                        hasHeader={false}
                        element={<ForgetPassword />}
                        allowRole={null}
                    />
                }
            />
            <Route
                path="/admin/documents"
                element={<Ro element={<AdminDocuments />} allowRole={0} />}
            />
            <Route
                path="/chat"
                element={<Ro element={<Chatbot />} allowRole={100} />}
            />
            <Route
                path="*"
                element={
                    <Ro
                        element={<NotFound />}
                        allowRole={null}
                    />
                }
            />
        </Routes>
    );
}
